export const mobileAppHandoffCardStyles = `
  .mah-card {
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-4);
    padding: var(--space-8) var(--space-6);
    border-radius: var(--radius-lg);
    border: 1px solid var(--glass-border);
    border-top-color: var(--glass-border-top);
    background: var(--glass-bg-strong);
    box-shadow: var(--glass-shadow);
    backdrop-filter: blur(var(--glass-blur));
    -webkit-backdrop-filter: blur(var(--glass-blur));
  }
  .mah-logo {
    height: 40px;
    width: auto;
  }
  .mah-title {
    margin: 0;
    font-size: var(--fs-2xl);
    font-weight: 700;
    color: var(--catchup-gray-600);
  }
  .mah-desc {
    margin: 0;
    font-size: var(--fs-base);
    line-height: 1.5;
    color: var(--catchup-gray-400);
  }
  .mah-actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    margin-top: var(--space-2);
  }
`;
